/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Cue_5Inputs */

const en_us2_workout_cue_5 = /** @type {(inputs: Workout_Cue_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shake out your hands and relax your grip.`)
};

const pt_br2_workout_cue_5 = /** @type {(inputs: Workout_Cue_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sacuda as mãos e relaxe a pegada.`)
};

const es_419_workout_cue_5 = /** @type {(inputs: Workout_Cue_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sacude las manos y relaja el agarre.`)
};

const pt_pt2_workout_cue_5 = /** @type {(inputs: Workout_Cue_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sacode as mãos e relaxa a pega.`)
};

const fr_fr2_workout_cue_5 = /** @type {(inputs: Workout_Cue_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secoue les mains et relâche ta prise.`)
};

const de_de2_workout_cue_5 = /** @type {(inputs: Workout_Cue_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schüttel die Hände aus und lockere den Griff.`)
};

const it_it2_workout_cue_5 = /** @type {(inputs: Workout_Cue_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scuoti le mani e rilassa la presa.`)
};

/**
* | output |
* | --- |
* | "Shake out your hands and relax your grip." |
*
* @param {Workout_Cue_5Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_cue_5 = /** @type {((inputs?: Workout_Cue_5Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Cue_5Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_cue_5(inputs)
	if (locale === "es-419") return es_419_workout_cue_5(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_cue_5(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_cue_5(inputs)
	if (locale === "de-DE") return de_de2_workout_cue_5(inputs)
	if (locale === "it-IT") return it_it2_workout_cue_5(inputs)
	return en_us2_workout_cue_5(inputs)
});
export { workout_cue_5 as "workout.cue_5" }